<template>
  <div class="container-fluid">
    <div class="row marketing">
      <div class="col-3">
        <h4 class="form-head">
          Config
        </h4>
        <form name="pform">
          <div class="form-group">
            <label for="opin">Common Alert EMails</label>
            <textarea class="form-control"
                   id="opin"
                   v-model="tenant.alertEMails"
                      placeholder="Enter EMails One Per Line"></textarea>

          </div>
          <button type="button" v-on:click="saveAlertEMail()" class="btn btn-primary mt-3">
            <i class="fa fa-save"></i> Save
          </button>
        </form>
      </div>
    </div>
</div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'EwbConfigPage',
  created: function () {
    this.$store.dispatch('isLoggedIn').then(() => {
      if (!this.$store.state.loggedIn) {
        console.log('Not Logged-in')
        this.$router.push('login')
      }
      this.loadTenant()
    }, _ => {
      console.error('isLoggedIn Failed, lets go to login')
      this.$router.push('login')
    })
  },
  data () {
    return {
      creds: [],
      tenant: {}
    }
  },
  methods: {
    loadTenant: function () {
      axios.get('/app/tenant').then(resp => {
        this.tenant = resp.data
      })
    },
    saveAlertEMail: function () {
      let data = {
        emails: this.tenant.alertEMails
      }
      console.log(data)
      axios.post(`/app/tenant/update`, data).then(_ => {
        console.log('saved')
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/admin/EwbConfigPage.vue